import React from 'react';
import { Card, CardContent, CardActions, Button, CardMedia, Typography, useTheme, useMediaQuery } from '@mui/material';

type ReusableCardProps = {
  imageUrl: string | undefined;
  altText?: string;
  title: string;
  subtitle?: string;
  button1Label?: string;
  button2Label?: string;
  onButton1Click?: () => void;
  onButton2Click?: () => void;
  labelAtt?: boolean;
  company: boolean;
};
  
import defaultDam from '../../imgs/defaultDam.svg';
import defaulCompany from '../../imgs/dafaultCompany.svg';


  export const VCard: React.FC<ReusableCardProps> = ({
    imageUrl,
    altText,
    title,
    subtitle,
    button1Label,
    button2Label,
    onButton1Click,
    onButton2Click,
    labelAtt = true,
    company
  }) => {

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));


    return (
      <Card sx={{ borderRadius: 5, backgroundColor: theme.palette.background.default}}>
        {imageUrl == null || imageUrl == undefined ?
          company ? <CardMedia component="img" alt={altText} image={defaulCompany}  sx={{ height: smDown ? 150 : 300, objectFit: smDown ? 'contain' : 'fill', backgroundColor: 'white'  }} /> : <CardMedia component="img" alt={altText} image={defaultDam}  sx={{ height: smDown ? 150 : 300, objectFit: smDown ? 'contain' : 'fill', backgroundColor: 'white'}} />
          : <CardMedia component="img" alt={altText} src={`data:image/jpeg;base64, ${imageUrl}`}  sx={{ height: smDown ? 150 : 300, backgroundColor: 'white', objectFit: smDown ? 'contain' : 'fill'}} />
        } 
        <CardContent>
          <Typography variant="h5" component="div" marginBottom={'5px'}>
            {title}
          </Typography>
          {labelAtt &&
            <div>
              <Typography variant="subtitle2">Última atualização</Typography>
              <Typography variant="subtitle1" marginBottom={'-15px'}>{subtitle}</Typography>
            </div>
          }
        </CardContent>
        <CardActions >
          <Button onClick={onButton1Click} variant='text' color='primary'>{button1Label}</Button>
          <Button onClick={onButton2Click} variant='text' color='primary'>{button2Label}</Button>
        </CardActions>
      </Card>
    );
  };

